import './assets/css/tailwind.css'
import './assets/css/base.css'

import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'

// 創建 pinia
import ModalBox from '@/components/Modal/Box.vue'
import router from './router'

import Button from '@/components/Button'
import SvgIcon from '@/components/SvgIcon'

import '@/scripts/vee-validate.js'

const requireAll = (requireContext) => requireContext.keys().map(requireContext)
const req = require.context('@/assets/svg', true, /\.svg$/)
requireAll(req)

const app = createApp(App)

const pinia = createPinia()

app
  .component('Btn', Button)
  .component('SvgIcon', SvgIcon)
  .component('ModalBox', ModalBox)

app.use(pinia).use(router).mount('#app')
